module.exports = __webpack_public_path__ + "img/title-bg.934c75b4.png";